import { initAnalytics, trackPageview } from "@/lib/analytics";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Mounts the first-party analytics capture once and fires a pageview on every
 * client-side route change. Rendered inside <Layout> so it lives under the
 * router (useLocation) on whichever host serves the SPA. Renders nothing.
 */
export function Analytics() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
